document.addEventListener('click', (e) => {
  const btn = e.target.closest('.swatch-more--mobile-only');
  if (!btn) return;

  const card =
    btn.closest('.product-card-wrapper') ||
    btn.closest('.card-wrapper') ||
    btn.closest('.grid__item');

  if (!card) return;

  card.classList.add('swatch-expanded');
  btn.setAttribute('aria-expanded', 'true');
});